import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { HeaderDto } from '../../dto/header.dto';
import {
  DocTypes,
  FileNode,
  FileService,
  GetFileTreeResponse,
  NodeType
} from '../../services/file.service';
import { UploadDocumentsService } from '../../services/docs-service/upload-documents.service';
import { ErrorToastService } from '../../services/error-toast.service';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-file-page',
  templateUrl: './file-page.component.html',
  styleUrls: ['./file-page.component.scss']
})
export class FilePageComponent implements OnInit {
  headerDataValues: HeaderDto = {
    title: 'Документы'
  };

  dealId!: number;
  fileTree$ = new BehaviorSubject<GetFileTreeResponse>({
    success: false,
    data: { nodes: [] }
  });

  forwarderDocuments$ = new BehaviorSubject<FileNode[]>([]);
  mainDocuments$ = new BehaviorSubject<FileNode[]>([]);

  defaultBackUrl: string = '/requests';

  constructor(
    private route: ActivatedRoute,
    private fileService: FileService,
    private uploadDocumentsService: UploadDocumentsService,
    private errorToastService: ErrorToastService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.dealId = Number(params.get('dealId'));
      this.refreshDocuments();
    });
  }

  public openUploadOtherDocuments(): void {
    this.uploadDocumentsService
      .uploadDocumentsFlow(this.dealId, 'FORWARDING_OTHER_DOC')
      .subscribe({
        next: () => {
          void this.errorToastService.showSuccess('Файл успешно загружен');
          this.refreshDocuments();
        },
        error: err => {
          Sentry.captureException(err);
          void this.errorToastService.showError('Ошибка при загрузке файла');
          this.refreshDocuments();
        }
      });
  }

  private findNestedDocuments(
    nodes: FileNode[],
    documentType: DocTypes
  ): FileNode[] {
    let result: FileNode[] = [];

    for (const node of nodes) {
      if (node.items && node.items.length) {
        const docsInGroup = node.items.filter(
          item =>
            item.nodeType === NodeType.DOCUMENT &&
            item.documentType === documentType
        );
        result = [...result, ...docsInGroup];

        const nestedDocs = this.findNestedDocuments(node.items, documentType);
        result = [...result, ...nestedDocs];
      }
    }

    return result;
  }

  private removeNestedDocuments(
    nodes: FileNode[],
    documentType: DocTypes
  ): void {
    for (const node of nodes) {
      if (node.items && node.items.length) {
        node.items = node.items.filter(
          item =>
            !(
              item.nodeType === NodeType.DOCUMENT &&
              item.documentType === documentType
            )
        );

        this.removeNestedDocuments(node.items, documentType);
      }
    }
  }

  private refreshDocuments(): void {
    this.fileService.getDealFiles(this.dealId).subscribe(fileTree => {
      this.fileTree$.next(fileTree);

      if (fileTree.success) {
        const forwarderDocs = fileTree.data.nodes.filter(
          node =>
            node.nodeType === NodeType.DOCUMENT &&
            node.documentType === DocTypes.FORWARDING_OTHER_DOC
        );

        const nestedDocs = this.findNestedDocuments(
          fileTree.data.nodes,
          DocTypes.FORWARDING_OTHER_DOC
        );

        this.forwarderDocuments$.next([...forwarderDocs, ...nestedDocs]);
        const filteredNodes = JSON.parse(JSON.stringify(fileTree.data.nodes));

        const mainDocs = filteredNodes.filter(
          (node: FileNode) =>
            !(
              node.nodeType === NodeType.DOCUMENT &&
              node.documentType === DocTypes.FORWARDING_OTHER_DOC
            )
        );

        this.removeNestedDocuments(mainDocs, DocTypes.FORWARDING_OTHER_DOC);

        this.mainDocuments$.next(mainDocs);
      } else {
        this.forwarderDocuments$.next([]);
        this.mainDocuments$.next([]);
      }
    });
  }
}
